"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTeamMembers = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _teamMembers = require("../store/entities/teamMembers/teamMembers.selectors");

var _teamMembers2 = require("../store/entities/teamMembers/teamMembers.actions");

var useAll = function useAll() {
  return (0, _reactRedux.useSelector)(_teamMembers.getTeamMembers);
};

var useIds = function useIds() {
  return (0, _reactRedux.useSelector)(_teamMembers.getTeamMembersIds);
};

var useEntities = function useEntities() {
  return (0, _reactRedux.useSelector)(_teamMembers.getTeamMembersMap);
};

var useGetById = function useGetById(id) {
  return (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return id ? (0, _teamMembers.getTeamMemberById)(id) : function () {
      return undefined;
    };
  }, [id]));
};

var useTeamMembers = function useTeamMembers(teamId) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var storedTeamId = (0, _reactRedux.useSelector)(_teamMembers.getTeamMembersFetchedTeamId);
  var isPending = (0, _reactRedux.useSelector)(_teamMembers.getIsTeamMembersLoading);
  var isFulfilled = (0, _reactRedux.useSelector)(_teamMembers.getIsTeamMembersLoaded);
  var isIdle = (0, _reactRedux.useSelector)(_teamMembers.getIsTeamMembersIdle);
  (0, _react.useEffect)(function () {
    if (teamId && (isIdle || storedTeamId !== teamId)) {
      dispatch((0, _teamMembers2.loadTeamMembersRequest)(teamId));
    }
  }, [teamId, isIdle, storedTeamId, dispatch]);
  var reset = (0, _react.useCallback)(function () {
    dispatch((0, _teamMembers2.resetTeamMembers)());
  }, [dispatch]);
  return (0, _react.useMemo)(function () {
    return {
      isIdle,
      isPending,
      isFulfilled,
      useEntities,
      useIds,
      useAll,
      useGetById,
      reset
    };
  }, [isIdle, isPending, isFulfilled, reset]);
};

exports.useTeamMembers = useTeamMembers;